<div class="w-100 mb-sm-3">
  <div class="d-flex">
    <app-sidebar [products]="webListings" class="d-md-flex d-none sidebar-scroll" (selectedFilter)="applyFilter($event)"></app-sidebar>

    <div class="w-md-75 w-100">
      <section class="px-3">
        <app-top-filter [products]="webListings" (selectedFilter)="applyFilter($event)"></app-top-filter>
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-6 p-0" *ngFor="let listing of webListings">
            <app-product [product]="listing" [cartEnabled]="true"></app-product>
          </div>
          <div *ngIf="!loading && webListings.length == 0">
            <app-no-data></app-no-data>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
